(function( $ ) {

    function check_frm_final_total() {
        var total_val = $('.frm_final_total').val();
        if (Number(total_val) > 0) {
            $('#formidable-addons-total').show();
        } else {
            $('#formidable-addons-total').hide();
        }
    }

    if ($('.frm_final_total').length) {
        check_frm_final_total();
        $('.frm_final_total').on('change', function() {
            check_frm_final_total();
        });
    }

})(jQuery);